import React, { useEffect, useState } from 'react'

// Node Modules
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import NavDropdown from 'react-bootstrap/NavDropdown'

// Components
import * as service from './TabBar.service'
import { MenuIcon } from 'components/SASIcon'

// Types
import { Navigation, EntryNode, ParentNode } from 'types/navigation'

// Styles
import styles from './TabBar.module.scss'

interface Props {
  alias: string
  cfr: string
  nav: string
}

const TabBar = ({alias, cfr, nav}:Props) => {
  const { t } = useTranslation()
  const [navigation, setNavigation] = useState<Navigation | undefined>()

  useEffect(() => {
    service.getNavigation(alias, cfr, nav).then(setNavigation)
  }, [nav, alias, cfr])

  if (!navigation) {
    return <React.Fragment />
  }  

  const handleKey =(e: React.KeyboardEvent)=> {
    if (e.keyCode === 9 || e.keyCode === 32) {
      e.stopPropagation()
    } 
    if (e.keyCode === 13 || e.keyCode === 32) {
      e.preventDefault()
      let target = e.currentTarget as HTMLElement
      
      let elem: HTMLElement | null = document.querySelector('#MainContentSection')
      target.click()
      elem && elem.focus()
    }
  }

  return (
    <Navbar className={styles.tabbar} expand="md" role="application">
      <Navbar.Toggle className={styles.toggle} label={t('helpcenter-gui-icu.content.tabbar.toggle.label')}>
        <MenuIcon />
      </Navbar.Toggle>
      <Navbar.Collapse>
        <Nav className={styles.nav}>
          { 
            navigation.navigation.map(nav => {
              if (nav.type === "parent") {
                const parent = nav as ParentNode

                return (
                  <NavDropdown className={styles.link} title={parent.label} id={parent.label} focusFirstItemOnShow="keyboard" key={parent.label}>
                    { parent.children.map(child => (
                      <NavDropdown.Item as={Link} to={child.file} onKeyDown={handleKey} key={child.file}>{ child.label }</NavDropdown.Item>
                    ))}
                  </NavDropdown>
                )
              } else {
                const entry = nav as EntryNode

                return (
                  <Nav.Item className={styles.item} key={entry.file}>
                    <Nav.Link className={styles.link} as={Link} to={entry.file} onKeyDown={handleKey} >{ entry.label }</Nav.Link>
                  </Nav.Item>
                )
              }          })}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  )
}

export default TabBar